export default {
  personalDetails: 'Personal details',
  workExperience: 'Work experience',
  preference: 'Preference',
  viewFile: 'Your uploaded file',
  jobProfile: 'Job Profile',
  fields: {
    name: 'Full Name *',
    gender: 'What is your gender? *',
    qualification: 'What is your highest qualification? *',
    specialisation: 'What is your specialisation?',
    resume: 'Do you have a resume?',
    experience: 'How long were you working *',
    pastEmployer: 'Your past employer?',
    designation: 'Your recent designation?',
    salary: 'Your recent salary?',
    jobCategory: 'What kind of job are you looking for *',
    preferredLocation: 'Your preferred location? *',
    jobType: 'Your preferred job type *',
    workType: 'Your preferred work type *',
    shiftTiming: 'Your preferred work time *'
  },
  uploadResume: 'Upload your resume',
  uploadText: 'You can upload a .jpg, .pdf or a word doc. OR take a picture',
  optional: 'Optional',
  placeholders: {
    name: 'Provide your full name for recruiters',
    specialisation: 'eg: Engineering, Arts',
    pastEmployer: 'eg: TCS, Wipro',
    designation: 'eg: Sales Manager',
    salary: 'Choose a salary range',
    jobCategory: 'Choose job categories',
    preferredLocation: 'Select multiple districts',
    searchForJobs: 'Search for jobs',
    signUp: 'Signup'
  },
  buttons: {
    uploadResume: 'Upload resume',
    capture: 'Take a picture',
    uploadFromDevice: 'Upload from device',
    next: 'Next',
    submit: 'Submit',
    done: 'Done',
    viewFile: 'View File',
    delete: 'Delete',
    change: 'Change',
    pause: 'Pause',
    retry: 'Retry'
  },
  allStates: 'Anywhere in {state}',
  jobCategory: 'Job Category',
  preferredLocation: 'Preferred Location',
  salary: 'Choose Salary Range',
  resume: 'Resume',
  recommendedJobs: 'Recommended jobs',
  sponsoredJobs: 'Sponsored jobs',
  footerFields: {
    CustomerServices: 'Customer Services',
    emailUs: 'Email us',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and conditions',
    needJob: 'Need a job near you?',
    jobs: '1 lakh jobs',
    sections: '40 sections'
  },
  emptyResultsScreenFields: {
    jobsByCategories: 'Jobs by Categories',
    jobsByLocation: 'Jobs by Location',
    headerMessage1: 'Sorry, we could not find any open roles for your search',
    headerMessage2: 'Signup for Job alerts and we’ll notify you when new jobs have opened up',
    explore: 'Explore jobs by categories and location',
    noOfJobs: '10 jobs',
    icon: 'icon'
  },
  exploreJobsFiltersFields: {
    Category: 'Category',
    salaryRange: 'Salary Range',
    Experience: 'Experience',
    exploreJobsHero: 'Explore by job categories'
  },
  faqFields: {
    header: 'Frequently asked questions'
  },
  homePageHeroFields: {
    findDreamJob: 'Find your dream job!',
    availableJobsAndNoOfCities: ' 50 Lakh+ Jobs | 70+ Cities',
    content: 'Apply for jobs on Lokalapp & talk to the HRs of the companies directly.'
  },
  appalyForJob: 'Apply for a Job',
  searchJob: 'Search job',
  postAJob: 'Post A job',
  jobFindingStepsFields: {
    step1: '1. Create your job Profile',
    step2: '2. Find a job vacancy',
    step3: '3. Contact the HR directly to Apply',
    hero: 'Find your dream job using Lokal in 3 simple steps:'
  },
  jobSearchPlaceHolder: 'Search for jobs',
  share: 'Share',
  shareOnWhatsApp: 'Share on WhatsApp',
  report: 'Report',
  viewJobs: 'View jobs',
  lookingForJobHero: {
    hero: 'Looking for a job?',
    content: 'The sky was cloudless and had a deep blue hue.'
  },
  postNewJobFields: {
    hero: 'Post your work Local application in 3 simple steps:',
    content1: 'Target job advertising from 250+ districts',
    content2: 'Recruit from 1 lakh eligible candidates',
    content3: 'Get maximum responses at low rates'
  },
  quickAccessFooterFields: {
    quickLinks: 'Quick Links',
    categoryWiseJobs: 'Category wise jobs',
    jobsByLocation: 'Jobs by location',
    viewAllCategories: 'View all categories',
    viewAllLocations: 'View all locations'
  },
  jobSearchPlaceHolder1: 'Enter Job title, keyword,...',
  warangal: 'warangal',
  krishna: 'krishna',
  vishakapatnam: 'Vishakapatnam',
  yadadri: 'yadadri',
  guntur: 'guntur',
  jobs: 'Jobs',
  seeAll: 'See all',
  jobListing: 'Job Listing',
  findAJob: 'Find a job',
  createAnAccount: 'Create an account',
  jobSearchAdvice: 'Job Search Advice',
  administration: 'Administration',
  digitalMarketing: 'Digital Marketing',
  design: 'Design',
  development: 'Development',
  productmanagement: 'Product management',
  finance: 'Finance',
  agra: 'Agra',
  bengaluru: 'Bengaluru',
  delhi: 'Delhi',
  mumbai: 'Mumbai',
  hi: 'Hi',
  home: 'Home',
  exploreJobs: 'Explore Jobs',
  postAJob: 'Post a Job',
  contactUs: 'Contact Us',
  contact: 'contact',
  getTheApp: 'Get the App',
  loginOrCreateAnAccount: 'Login or Create an account',
  login: 'Login',
  createYourProfile: 'Create profile',
  editProfile: 'Edit Profile',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  disclosureTitle: {
    jobDetails: 'Job Details',
    feesRequired: 'Fees Required',
    noFeeIsRequired: 'No fee is required'
  },
  whyIsItNeeded: 'Why is it needed',
  emailUsOn: 'email us on',
  similarJobs: 'Similar Jobs',
  noSimilarJobs: 'No similar Jobs',
  loading: 'Loading',
  enterNewMobileNumber: 'Enter new mobile number',
  mobileNumber: 'Mobile Number',
  anOtpWillBeSentToThisNumber: 'An OTP will be sent to this number',
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  noResultsFoundFor: 'No results found for',
  jobsTitle: 'Jobs in {location} | Find Job Vacancies in {location} : {host}/jobs',
  jobsMetaData:
    'Apply for Jobs in {location} on {host}/jobs. Register for Free & Find Job Openings in {location}',
  posted: 'Posted',
  ago: 'ago',
  views: 'views',
  cancel: ' cancel',
  pleaseTryAgain: 'Please try again',
  locationsNotAvailable: 'Locations not available',
  jobsByCategories: 'Jobs by category',
  footerModelForApplyJobFields: {
    header1: 'Are you sure want to continue',
    header2: 'Job Application has been succesfully Submitted',
    applyConformation: 'applying for this job?',
    subText1: 'if selected,you will receive a call from the recuiter',
    subText2: 'Your details will be sent to the recruiter'
  },
  advertiser: {
    whatOurUsersSay: 'What our employers have to say about Lokal'
  },
  searchJobs: 'Search Jobs',
  createFreeAccount: 'Create free account',
  jobAdvice: 'Job Advice',
  postAJob: 'Post a Job',
  mobileNumber: 'Mobile Number',
  sendOTP: 'Send OTP',
  verifyOTP: 'Verify OTP',
  downLoadApp: 'Download the app',
  jobsNearMeTitle: '{numberOfJobs} Job Openings & Vacancies  - Find the Perfect Job',
  jobsDescription:
    'Searching for jobs in {Location}? Find the latest openings and vacancies in {Location} in 2023 with Lokal Job Listings',
  postJobSteps: {
    jobDetail: 'जॉबची माहिती',
    aboutJob: 'जॉबबद्दल',
    selectRole: 'जॉबची भूमिका निवडा',
    selectTitle: 'नोकरीचे शीर्षक निवडा',
    postTitle: 'पोस्ट शीर्षक प्रविष्ट करा',
    sampleJobTypes: 'जसे की, सेल्स अकाउंटंट, डिलीव्हरी बॉय, इ.',
    addJobDescription: 'जॉबची माहिती प्रविष्ट करा',
    removeJobDescription: 'नोकरीचे वर्णन काढा',
    NoOfOpenings: 'एकूण जागा',
    enterNoOfOpenings: 'एकूण जागा प्रविष्ट करा',
    monthlyIncome: 'मासिक उत्पन्न',
    enterMinSalary: 'किमान पगार प्रविष्ट करा',
    enterMaxSalary: 'कमाल पगार प्रविष्ट करा',
    jobShift: 'जॉबची शिफ्ट',
    dayShift: 'दिवसाची शिफ्ट',
    nightShift: 'रात्रीची शिफ्ट',
    anyShift: 'कोणतीही शिफ्ट',
    jobType: 'जॉबचा प्रकार',
    fieldJob: 'फिल्ड जॉब',
    officeJob: 'ऑफिस जॉब',
    workFromHome: 'वर्क फ्रॉम होम',
    industryJob: 'इंडस्ट्री जॉब',
    officeLocation: 'कार्यालय स्थान',
    interstedPlace: 'तुम्ही कोणत्या ठिकाणचे लोक कामावर घेण्यास इच्छुक आहात?',
    district: 'जिल्हा',
    selectMultipleDistricts: 'अधिक जिल्हे निवडा',
    charges: 'या जॉबकरिता, आपण उमेदवारांकडून कोणती फी आकारणार आहात का',
    yes: 'हो',
    no: 'नाही',
    reasonForFee: 'कृपया फी योग्य कारणांसाठी आकारली जात आहे याची खात्री करा',
    feeAmount: 'एकूण फी (रूपयांमध्ये)',
    selectReasonsForFee: 'फीसाठी कारणे निवडा',
    registrationFee: 'नोंदणी फी',
    trainingFee: 'प्रशिक्षण फी',
    feeForOtherReasons: 'युनिफॉर्म, उपकरणे, साधने इत्यादींसाठी फी',
    securityDeposit: 'सिक्युरिटी डिपॉझिट',
    commission: 'कमिशन',
    otherReason: 'इतर कारण',
    specifyOtherReason: 'इतर कारण सांगा (असल्यास)',
    feeDueDate: 'फी केव्हा भरली जावी',
    afterGivingJob: 'जॉब मिळाल्यानंतर',
    beforeGivingJob: 'जॉब मिळण्याआधी',
    candidateRequirement: 'उमेदवाराची आवश्यकता',
    candidateQualification: 'उमेदवाराची पात्रता',
    selectMinimumEducation: 'किमान शिक्षण निवडा',
    selectYourExperience: 'अनुभवाची वर्षे निवडा',
    preferredGender: 'प्राधान्याचे लिंग',
    male: 'पुरूष',
    female: 'स्त्री',
    anyGender: 'कोणतेही',
    contactCandidatesThrough: 'उमेदवारांना याद्वारे व्यवस्थापित करा',
    callOnWhatsapp: 'कॉल आणि व्हॉटस्ॲप',
    callOnly: 'केवळ कॉल',
    whatsappNo: 'क्रमांक व्हॉटस्ॲप समान',
    next: 'पुढे',
    companyDetail: 'कंपनीची माहिती',
    selectCompanyType: 'तुमच्या कंपनीचा प्रकार निवडा',
    consultancy: 'कन्सल्टन्सी/मॅनपॉवर फर्म',
    hiresThirdPartyCompany: 'मी थर्ड पार्टी कंपनीसाठी नोकरी देतो',
    company: 'कंपनी',
    hireForMyComapny: 'मी माझ्या कंपनी/स्टोअरसाठी नोकरी देतो',
    company: 'कंपनी',
    companyname: 'कंपनीचे नाव प्रवमष्ट करा',
    companySize: 'कंपनीचा आकार',
    largeScale: 'मोठ्या-आकाराची [50+ कर्मचारी]',
    midScale: 'मध्यम-आकाराची [20-50 कर्मचारी]',
    smallScale: 'लहान आकाराची [5-20 कर्मचारी]',
    companyNameToBeDisplayed: 'या नोकरीसाठी उमेदवारांना कंपनीचे नाव दाखवावे',
    consultancyName: 'सल्लागार नाव',
    otherThirdPartyname: 'इतर तृतीय-पक्ष कंपनीचे नाव',
    jobDescriptionPlaceholder: 'कर्मचाऱ्यांच्या जबाबदाऱ्या कोणत्या असतील?',
    officeLocationCityPlaceholder: 'शहर / नगर शोधा',
    officeLocationAreaPlaceholder: 'क्षेत्र / विभाग शोधा',
    noOptionsDropdown: 'पर्यायांसाठी टाइप करा',
    selectDistrict: 'जिल्हा निवडा',
    selectDistricts: 'जिल्हे निवडा',
    noDistrictSelected: 'निवड',
    whatsappNumber: 'व्हॉटस्ॲप क्रमांक',
    recruiterLogin: 'तुम्ही येथील रिक्रूटर म्हणून लॉग इन केले आहे',
    advertiserTooltip: 'हा जॉब पाहणाऱ्या उमेदवारांना हे नाव हायरिंग कंपनी म्हणून दाखवले जाईल.',
    consultancyManpowerFirm: 'Consultancy / Manpower firm',
    thirdPartyHire: 'I hire for third party companies',
    companyNew: 'Company',
    companyStore: 'I hire for my company / store',
    consultancyNameNew: 'कन्सल्टन्सीचे नाव एंटर करा',
    choosePlan: 'प्लान निवडा',
    noFeeWarning: 'कृपया कोणतेही शुल्क वसूल होणार नाही याची काळजी घ्या. उमेदवारांची फसवणूक करणाऱ्या जॉब पोस्ट काढून टाकण्याचा किंवा जाहिरातदार/कंपन्यांना ब्लॉक करण्याचा अधिकार लोकल ॲपकडे आहे.',
    feePaidQuestion: 'शुल्क केव्हा भरावे? (पर्यायी)',
    feePaidCaution: 'उमेदवारांची फसवणूक करणाऱ्या जॉब पोस्ट काढून टाकण्याचा किंवा जाहिरातदार/कंपन्यांना ब्लॉक करण्याचा अधिकार लोकल ॲपकडे आहे.',
    useCurrentLocation: 'करंट लोकेशन वापरा',
    skillsRequired: 'आवश्यक स्किल',
    addOtherSkills: 'इतर कौशल्ये ॲड करा',
    additionalSkills: 'अतिरिक्त स्किल',
    additionalSkillsMsg: 'तुम्ही जास्तीत जास्त 3 अतिरिक्त स्किल ॲड करू शकता',
    additionalSkillsPlaceholder: 'इतर स्किल कॉमाद्वारे वेगळे करून ॲड करा ',
    perDistrictChargeOne: 'तुम्ही सशुल्क प्लान खरेदी केल्यास तुमच्याकडून',
    perDistrictChargeTwo: 'प्रति जिल्हा आधारावर',
    perDistrictChargeThree: 'शुल्क आकारले जाईल',
    skillsSelectedPlaceholder: 'निवडलेले स्किल',
    industryLocation: 'उद्योगाचे लोकेशन',
    fieldLocation: 'फील्ड लोकेशन',
    workFromHome: 'नोंदणीकृत कार्यालयाचा पत्ता',
    submit: 'सबमिट करा',
    tncOne: 'पूर्ण',
    tncTwo: 'अटी व शर्ती',
    tncThree: 'वाचा',
    courseTitle: 'Select Course/Certificate',
    minEducation: 'Minimum Education',
    selectCoursePlaceholder: 'Select Course Name',
    courseName: 'Course name',
    optional: 'optional',
    experience: 'Experience',
    postingLocationMessage: 'You will receive candidates from',
    postingLocationModalTitle: 'Select hiring location',
    postingLocationSearchPlaceHolder: 'Search cities',
    //commented till translations not provided
    // proceedToPaySubtext: 'We follow fair use and privacy rules. Breaking policies or fraud can lead to account suspension and loss of service fees.',
    // checkout: 'Checkout',
    // checkoutInfo: 'Review your order and proceed with payment to unlock your benefits.',
    // orderSummary: 'Order Summary'
  },
  postJobErrorStates: {
    noOptions: 'कृपया एक पर्याय निवडा',
    wrongValue: 'कृपया योग्य व्हॅल्यू ॲड करा',
    noOpenings: 'कृपया ओपनिंगची संख्या निर्दिष्ट करा',
    noMonthlySalary: 'कृपया मासिक वेतनाची माहिती द्या',
    lowMinSalary: 'किमान वेतन 1000 पेक्षा कमी नाही याची खात्री करा',
    highMinSalary: 'किमान मासिक वेतन रु. 1,00,000 पेक्षा कमी असावे.',
    noFeeAmount: 'कृपया शुल्काची रक्कम एंटर करा (in ₹)',
    lowMaxSalary: 'जास्तीत जास्त वेतन 1000 पेक्षा कमी नाही याची खात्री करा',
    highMaxSalary: 'जास्तीत जास्त मासिक वेतन रु. 1,00,000 पेक्षा कमी असावे.',
    minGreaterMax: 'जास्तीत जास्त वेतन किमान वेतनापेक्षा जास्त असावा',
    noTextArea: 'कृपया टेक्स्ट एरिया भरा',
    noPhoneNumber: 'कृपया फोन नंबर एंटर करा',
    noConsultancyName: 'कृपया कन्स्ल्टन्सीचे नाव एंटर करा',
    noCompanyName: 'कृपया कंपनीचे नाव एंटर करा',
    noCompanyType: 'कृपया कंपनीचा प्रकार निवडा',
    noDataFound: 'No Data Found'
  }
}
